
import * as Yup from "yup";



export const formikNotes = {
  initialValues: {
    _id: null,
    title: "",
    content: "",
    patientID :"",
    providerID: "",
 
   
  },
  validationSchema: Yup.object({
    
    title: Yup.string().required("Required Field"),
    content: Yup.string().required("Required Field"),

  
   
  }),
};
